function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 1.75H15.6893L20.25 6.31066V22.25H3.75V1.75Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 1.5V6.5H20.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 10.5H11.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 14H16.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 17.5H16.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgDocument = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Document.2d76d262.svg";
export { ForwardRef as ReactComponent };